import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type StateService from 'garaje/services/state';

import type LocationOverviewHrisNotificationsController from './controller';
import type { NotificationsModel } from './controller';

export default class LocationOverviewHrisNotificationsRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;
  @service declare state: StateService;

  async model(): Promise<NotificationsModel> {
    return this.ajaxFetch.request(`/api/v1/hris/notifications?company_id=${this.state.currentCompany.id}`);
  }

  setupController(
    controller: LocationOverviewHrisNotificationsController,
    model: NotificationsModel,
    transition: Transition<unknown>,
  ): void {
    super.setupController(controller, model, transition);
    controller.setupFromModel();
  }
}
